/*
 * Collection card swatch pricing
 * ------------------------------------------------------------
 * When a shopper hovers/taps a colour swatch on a collection card,
 * this updates that card's PRICE, SALE badge and CLICK-THROUGH LINK
 * to match the selected colour — using the data-* attributes rendered
 * in product.swatches.liquid. The existing theme code already swaps
 * the product IMAGE; this only adds the price/badge/link behaviour.
 *
 * Added for BraForMe to fix colour-variant pricing on collection pages.
 */
(function () {
  var CARD_SELECTOR = '.klevuProduct';

  // Normalise "£37.00" -> "£ 37.00" to match Klevu's on-page formatting.
  function formatPrice(value) {
    if (!value) return value;
    return value.replace(/^(\D+?)\s*(\d)/, '$1 $2');
  }

  function applySwatch(swatch) {
    var card = swatch.closest(CARD_SELECTOR);
    if (!card) return;

    var price = swatch.getAttribute('data-price');
    if (!price) return; // swatch has no pricing data; nothing to do

    var onSale = swatch.getAttribute('data-onsale') === 'true';
    var compare = swatch.getAttribute('data-compare');
    var url = swatch.getAttribute('data-url');

    // Match Klevu's price formatting: currency symbol + single space + amount
    // (Shopify's money filter omits the space; Klevu includes it). Works for
    // any symbol-prefixed currency, so it stays correct across markets.
    price = formatPrice(price);
    compare = formatPrice(compare);

    // --- Price block (rebuilt to match the theme's Klevu markup) ---
    var priceEl = card.querySelector('.kuSalePrice');
    var container = priceEl ? priceEl.parentElement : null;
    if (container) {
      if (onSale && compare) {
        container.innerHTML =
          '<span class="kuOrigPrice kuClippedOne text-grey-120 -tracking-2"><s>' + compare + '</s></span>' +
          '<span class="kuSalePrice text-highlight kuSpecialPrice kuClippedOne tracking-1 text-black">' + price + '</span>';
      } else {
        container.innerHTML =
          '<span class="kuSalePrice tracking-1">' + price + '</span>';
      }
    }

    // Note: sale badges are intentionally left to the theme's own logic and
    // your sale-badge setting — this script does not add or remove them.

    // --- Click-through link to the selected colour's product ---
    if (url) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }
  }

  // Works for swatches injected by Klevu after page load (event delegation).
  ['mouseover', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var swatch = e.target && e.target.closest ? e.target.closest('.js-swatches-image') : null;
      if (swatch) applySwatch(swatch);
    }, true);
  });
})();
